import { useContext } from 'react';

import { CampaignContext } from './campaign-context';

// ----------------------------------------------------------------------

export function useCampaignContext() {
  const context = useContext(CampaignContext);

  if (!context) throw new Error('useCheckoutContext must be use inside CheckoutProvider');

  return context;
}
